document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const menuToggle = event.target.closest('[data-vt-menu-toggle]');

  if (menuToggle) {
    const menu = document.querySelector('[data-vt-mobile-menu]');

    if (menu) {
      menu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', menu.classList.contains('is-open'));
    }
  }

  const backToTop = event.target.closest('[data-vt-back-to-top]');

  if (backToTop) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;

  const option = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  const idInput = form && form.querySelector('[name="id"]');
  const price = document.querySelector('[data-product-price]');
  const directButton = form && form.querySelector('[data-direct-purchase-button]');
  const status = form && form.querySelector('[data-direct-purchase-status]');
  const urgency = document.querySelector('[data-vt-urgency]');

  if (idInput) idInput.value = option.value;
  if (price && option.dataset.price) price.textContent = option.dataset.price;

  const available = option.dataset.available === 'true';
  if (directButton) directButton.classList.toggle('is-unavailable', !available);
  if (status) status.hidden = available;

  if (urgency && (urgency.dataset.mode === 'stock' || urgency.dataset.mode === 'limited')) {
    const inventory = Number(option.dataset.inventory || 0);
    const managed = option.dataset.inventoryManaged === 'true';
    const threshold = Number(urgency.dataset.stockThreshold || 5);
    const title = urgency.querySelector('[data-vt-urgency-title]');
    const subtitle = urgency.querySelector('[data-vt-urgency-subtitle]');
    const limitedTitle = urgency.dataset.limitedTitle || '🔥 Disponibilidad limitada';
    const limitedSubtitle = urgency.dataset.limitedSubtitle || 'Confirma disponibilidad al realizar tu pedido.';

    if (!managed) {
      urgency.dataset.mode = 'limited';
      urgency.hidden = !available;
      if (title) title.textContent = limitedTitle;
      if (subtitle) subtitle.textContent = limitedSubtitle;
    } else {
      urgency.dataset.mode = 'stock';
      const shouldShow = available && inventory > 0 && inventory <= threshold;
      urgency.hidden = !shouldShow;
      if (title && shouldShow) title.textContent = '¡Últimas ' + inventory + ' unidades!';
      if (subtitle && shouldShow) subtitle.textContent = 'Stock real disponible para esta variante.';
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const floatingTools = document.querySelector('[data-vt-floating-tools]');

  if (!floatingTools) return;

  const updateFloatingTools = function () {
    const shouldShow = window.scrollY > 500;
    floatingTools.hidden = false;
    floatingTools.classList.toggle('is-visible', shouldShow);
  };

  updateFloatingTools();
  window.addEventListener('scroll', updateFloatingTools, { passive: true });
});

function initVtHeroCarousels(scope) {
  (scope || document).querySelectorAll('[data-vt-hero-carousel]').forEach(function (carousel) {
    if (carousel.dataset.vtInitialized === 'true') return;
    carousel.dataset.vtInitialized = 'true';

    const track = carousel.querySelector('[data-vt-hero-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-vt-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-vt-hero-dot]'));
    const previous = carousel.querySelector('[data-vt-hero-prev]');
    const next = carousel.querySelector('[data-vt-hero-next]');
    const autoplay = carousel.dataset.autoplay === 'true';
    const interval = Number(carousel.dataset.interval) || 6000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;
    let touchStartX = 0;

    if (!track || slides.length < 2) return;

    const show = function (target) {
      index = (target + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stop = function () {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = function () {
      stop();
      if (autoplay && !reducedMotion) timer = window.setInterval(function () { show(index + 1); }, interval);
    };

    if (previous) previous.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(Number(dot.dataset.vtHeroDot)); start(); });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    carousel.addEventListener('touchstart', function (event) { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (event) {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 45) show(index + (distance < 0 ? 1 : -1));
      start();
    }, { passive: true });

    show(0);
    start();
  });
}

document.addEventListener('DOMContentLoaded', function () { initVtHeroCarousels(document); });
document.addEventListener('shopify:section:load', function (event) { initVtHeroCarousels(event.target); });


// VitrinaTop360: modo de compra directa sin carrito visible.
document.addEventListener('click', function (event) {
  const cartLink = event.target.closest('a[href$="/cart"], a[href*="/cart?"]');
  if (!cartLink) return;
  event.preventDefault();
  window.location.href = '/collections/all';
});
